module.exports = __webpack_public_path__ + "d205ca1376dbe5ce35b5b926fe739959.svg";